var moduleMap = {
	"./DepartmentManage": function() {
		return Promise.all([__webpack_require__.e(670), __webpack_require__.e(595)]).then(function() { return function() { return (__webpack_require__(595)); }; });
	},
	"./RoleManageEx": function() {
		return Promise.all([__webpack_require__.e(670), __webpack_require__.e(372)]).then(function() { return function() { return (__webpack_require__(6372)); }; });
	},
	"./AccountManageEx": function() {
		return Promise.all([__webpack_require__.e(670), __webpack_require__.e(129), __webpack_require__.e(819)]).then(function() { return function() { return (__webpack_require__(8819)); }; });
	}
};
var get = function(module, getScope) {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(function() {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = function(shareScope, initScope) {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: function() { return get; },
	init: function() { return init; }
});